import React from "react";
import { useSelector } from "react-redux";
import { DateStepper } from "@activecollab/components";
import PropTypes from "prop-types";
import { getFirstWeekDay } from "~/store/selectors/selector.configOptions.jsx";

export const DateStepperFirstWeekDay = ({ ...props }) => {
  const firstWeekDay = useSelector(getFirstWeekDay);
  return (
    <DateStepper
      {...props}
      period={firstWeekDay === 0 ? "week" : "isoWeek"}
      step={props.step}
    />
  );
};

DateStepperFirstWeekDay.propTypes = {
  step: PropTypes.string,
};

export default DateStepperFirstWeekDay;
